export const renderHighlightedTitle = (titleText: string) => {
  if (!titleText) return null;

  // de/fr put a space before "%": make it non-breaking so "75 %" never wraps
  // as "75" / "% Rabatt".
  const NBSP = String.fromCharCode(160);
  const parts = titleText.replace(/(\d)\s+%/g, `$1${NBSP}%`).split(/\*\*(.*?)\*\*/);

  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <span key={index} style={{ color: '#00CE00' }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};
